import OpenCashier from "./OpenCashier";
import GameLoadStart from "./GameLoadStart";
import GameLoadEnd from "./GameLoadEnd";
import BalanceChange from "./BalanceChange";
import GameSpinStart from "./GameSpinStart";
import GameSpinEnd from "./GameSpinEnd";
import CloseGame from "./CloseGame";
import OutOfMoney from "./OutOfMoney";
import SoundOff from './SoundOff';
import SoundOn from './SoundOn';
import RequestRefresh from "./RequestRefresh";
import KeepAlive from "./KeepAlive";
import RequestLogin from "./RequestLogin";
import RequestRegister from "./RequestRegister";
import Error from "./Error";
import Resize from "./Resize";
import GameHistory from "./GameHistory";
import FreeRoundsStart from "./FreeRoundsStart";
import FreeRoundsFinished from "./FreeRoundsFinished";
import RequestFullScreen from "./RequestFullScreen";
import ExitFullScreen from "./ExitFullScreen";
import OpenTable from "./OpenTable";
import GameRoundEnd from "./GameRoundEnd";
import Logout from "./Logout";
import LobbyLoadEnd from "./LobbyLoadEnd";
import UrlChanged from "./UrlChanged";
import WonAmountChange from "./WonAmountChange";
import GamePaused from "./GamePaused";
import GameResumed from "./GameResumed";
import GameAutoplayStart from "./GameAutoplayStart";
import GameAutoplayEnd from "./GameAutoplayEnd";
import BetAmountChange from "./BetAmountChange";
import GameLoadProgress from "./GameLoadProgress";
import OpenHelp from "./OpenHelp";
import ResetGame from "./ResetGame";
import CloseHelp from "./CloseHelp";
import ClosePaytable from "./ClosePaytable";
import OpenGame from "./OpenGame";

export default class Events {
    constructor(gb) {
        this.openCashier = new OpenCashier(gb);
        this.gameLoadStart = new GameLoadStart(gb);
        this.gameLoadEnd = new GameLoadEnd(gb);
        this.balanceChange = new BalanceChange(gb);
        this.gameSpinStart = new GameSpinStart(gb);
        this.gameSpinEnd = new GameSpinEnd(gb);
        this.closeGame = new CloseGame(gb);
        this.outOfMoney = new OutOfMoney(gb);
        this.soundOff = new SoundOff(gb);
        this.soundOn = new SoundOn(gb);
        this.requestRefresh = new RequestRefresh(gb);
        this.keepAlive = new KeepAlive(gb);
        this.requestLogin = new RequestLogin(gb);
        this.requestRegister = new RequestRegister(gb);
        this.error = new Error(gb);
        this.resize = new Resize(gb);
        this.gameHistory = new GameHistory(gb);
        this.freeRoundsStart = new FreeRoundsStart(gb);
        this.freeRoundsFinished = new FreeRoundsFinished(gb);
        this.openTable = new OpenTable(gb);
        this.gameRoundEnd = new GameRoundEnd(gb);
        this.logout = new Logout(gb);
        this.requestFullScreen = new RequestFullScreen(gb);
        this.exitFullScreen = new ExitFullScreen(gb);
        this.lobbyLoadEnd = new LobbyLoadEnd(gb);
        this.urlChanged = new UrlChanged(gb);
        this.betAmountChange = new BetAmountChange(gb);
        this.wonAmountChange = new WonAmountChange(gb);
        this.gamePaused = new GamePaused(gb);
        this.gameResumed = new GameResumed(gb);
        this.gameAutoplayStart = new GameAutoplayStart(gb);
        this.gameAutoplayEnd = new GameAutoplayEnd(gb);
        this.openHelp = new OpenHelp(gb);
        this.gameLoadProgress = new GameLoadProgress(gb);
        this.resetGame = new ResetGame(gb);
        this.closeHelp = new CloseHelp(gb);
        this.closePaytable = new ClosePaytable(gb);
        this.openGame = new OpenGame(gb);
    }

    exposeEvents() {
        return {
            ...this.openCashier.exposeEvent(),
            ...this.gameLoadStart.exposeEvent(),
            ...this.gameLoadEnd.exposeEvent(),
            ...this.balanceChange.exposeEvent(),
            ...this.gameSpinStart.exposeEvent(),
            ...this.gameSpinEnd.exposeEvent(),
            ...this.closeGame.exposeEvent(),
            ...this.outOfMoney.exposeEvent(),
            ...this.soundOff.exposeEvent(),
            ...this.soundOn.exposeEvent(),
            ...this.requestRefresh.exposeEvent(),
            ...this.keepAlive.exposeEvent(),
            ...this.requestLogin.exposeEvent(),
            ...this.requestRegister.exposeEvent(),
            ...this.error.exposeEvent(),
            ...this.resize.exposeEvent(),
            ...this.gameHistory.exposeEvent(),
            ...this.freeRoundsStart.exposeEvent(),
            ...this.freeRoundsFinished.exposeEvent(),
            ...this.openTable.exposeEvent(),
            ...this.gameRoundEnd.exposeEvent(),
            ...this.logout.exposeEvent(),
            ...this.requestFullScreen.exposeEvent(),
            ...this.exitFullScreen.exposeEvent(),
            ...this.lobbyLoadEnd.exposeEvent(),
            ...this.urlChanged.exposeEvent(),
            ...this.gameLoadProgress.exposeEvent(),
            ...this.betAmountChange.exposeEvent(),
            ...this.wonAmountChange.exposeEvent(),
            ...this.gamePaused.exposeEvent(),
            ...this.gameResumed.exposeEvent(),
            ...this.gameAutoplayStart.exposeEvent(),
            ...this.gameAutoplayEnd.exposeEvent(),
            ...this.openHelp.exposeEvent(),
            ...this.resetGame.exposeEvent(),
            ...this.closeHelp.exposeEvent(),
            ...this.closePaytable.exposeEvent(),
            ...this.openGame.exposeEvent(),
        }
    }
}
